"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadowRoot = getShadowRoot;
exports.inShadow = inShadow;
function inShadow(ele) {
  return (ele === null || ele === void 0 ? void 0 : ele.getRootNode()) !== (ele === null || ele === void 0 ? void 0 : ele.ownerDocument);
}
function getShadowRoot(ele) {
  return inShadow(ele) ? ele === null || ele === void 0 ? void 0 : ele.getRootNode() : null;
}